<template>
  <div class="box9" id="box9">
    <pageTitle
      title="他们的起点和你一样  只是选对了方向"
      text="从零基础到AI高薪岗，每一份offer都是真实的成长证明"
    />

    <div class="content">
      <div class="border">
        <div class="content-top">
          <div class="name name1">姓名</div>
          <div class="education">年龄	</div>
          <div class="before">就业薪资</div>
          <div class="after">入职公司</div>
          <div class="unit">就业岗位</div>
        </div>
      </div>

      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems1">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in salaryList"
          :key="index"
        >
          <div class="item">
            <div class="name">{{ item.name }}</div>
            <div class="education">{{ item.education }}</div>
            <div class="before">{{ item.major }}</div>
            <div class="after">{{ item.after }}</div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  
    <div class="btn-out"><ConsultBtn text="查看更多学员就业案例" /></div>
    
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
    ConsultBtn,
  },

  data() {
    return {
      swiperOption: {
        // swiper配置
        direction: "vertical", // 滑动方向改为垂直
        height: 72, //你的slide高度 强制性 垂直方向生效
        loop: true, //是否循环
        freeMode: true,
        speed: 1500,
        autoplay: {
          delay: 0, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        grabCursor: true,
        slidesPerView: "auto",
      },
      salaryList: [
        { name: "姚**", education: "27", major: "43000", after: "An**er", unit: "大模型算法" },
        { name: "朱**", education: "29", major: "32000", after: "杭州**公司", unit: "算法工程师" },
        { name: "孙*", education: "29", major: "30000", after: "保密", unit: "AI应用开发" },
        { name: "吕**", education: "36", major: "30000", after: "北大**究院", unit: "算法工程师" },
        { name: "刘**", education: "25", major: "30000", after: "**科技", unit: "算法应用" },
        { name: "于**", education: "29", major: "28000", after: "北京**公司", unit: "交付主管" },
        { name: "刘**", education: "28", major: "27000", after: "华信**公司", unit: "算法工程师" },
        { name: "张*", education: "27", major: "26250", after: "保密", unit: "保密" },
        { name: "种**", education: "28", major: "25000", after: "光**", unit: "RAG工程师" },
        { name: "刘**", education: "29", major: "23500", after: "**控股", unit: "算法工程师" },
        { name: "李**", education: "29", major: "23333", after: "华**", unit: "算法工程师" },
        { name: "张**", education: "28", major: "23000", after: "北京**公司", unit: "算法工程师" },
        { name: "杨*", education: "29", major: "23000", after: "雪浪**科技", unit: "算法工程师" },
        { name: "陈**", education: "22", major: "23000", after: "字****", unit: "大模型运营" },
        { name: "马**", education: "30", major: "22000", after: "中教**公司", unit: "算法工程师" },
        { name: "汪**", education: "31", major: "22000", after: "深圳**公司", unit: "后端开发" },
        { name: "杜**", education: "31", major: "22000", after: "北京**公司", unit: "算法工程师" },
        { name: "艾*", education: "25", major: "22000", after: "****驻场", unit: "大模型开发" },
        { name: "祝*", education: "33", major: "22000", after: "美****", unit: "大模型开发" },
        { name: "杜**", education: "22", major: "22000", after: "深圳**公司", unit: "算法工程师" },
        { name: "王**", education: "28", major: "21000", after: "保密", unit: "保密" },
        { name: "李**", education: "29", major: "21000", after: "上海**公司", unit: "软件工程师" },
        { name: "李*", education: "31", major: "21000", after: "保密", unit: "算法工程师" },
        { name: "张**", education: "33", major: "21000", after: "治享**券", unit: "系统架构师" },
        { name: "张**", education: "23", major: "20500", after: "**智能", unit: "大模型部署" },
        { name: "杨**", education: "28", major: "20000", after: "北京**公司", unit: "大模型开发" },
        { name: "李*", education: "33", major: "20000", after: "****动力", unit: "算法工程师" },
        { name: "薛**", education: "24", major: "20000", after: "人瑞**外包", unit: "PE专家" },
        { name: "孟*", education: "28", major: "20000", after: "平安**外包", unit: "算法工程师" },
        { name: "赵**", education: "27", major: "20000", after: "安徽**", unit: "算法工程师" },
        { name: "姚**", education: "31", major: "20000", after: "德科**公司", unit: "算法工程师" },
        { name: "申*", education: "37", major: "20000", after: "南京****公司", unit: "智能体开发" },
        { name: "宫**", education: "36", major: "20000", after: "上海****药业", unit: "信息分析" },
        { name: "梁*", education: "25", major: "20000", after: "南京****公司", unit: "算法工程师" },
        { name: "王**", education: "23", major: "20000", after: "联****", unit: "算法工程师" },
        { name: "万**", education: "27", major: "19000", after: "北京****公司", unit: "大模型开发" },
        { name: "崔**", education: "28", major: "19000", after: "北京****公司", unit: "AI后端开发" },
        { name: "赵**", education: "23", major: "18600", after: "****软件", unit: "算法工程师" },
        { name: "韩**", education: "26", major: "18500", after: "浙江****公司", unit: "数据处理" },
        { name: "王**", education: "27", major: "18500", after: "赛意****公司", unit: "算法工程师" },
        { name: "王*", education: "23", major: "18000", after: "高伟****公司", unit: "算法工程师" },
        { name: "彭**", education: "28", major: "18000", after: "广东****公司", unit: "算法工程师" },
        { name: "刘**", education: "26", major: "18000", after: "南京****公司", unit: "软件开发" },
        { name: "董**", education: "25", major: "18000", after: "****移民", unit: "算法工程师" },
        { name: "李**", education: "23", major: "18000", after: "****外包", unit: "算法工程师" },
        { name: "汤**", education: "28", major: "18000", after: "长沙****公司", unit: "算法工程师" },
        { name: "吴**", education: "25", major: "18000", after: "筏渡****公司", unit: "算法工程师" },
        { name: "方**", education: "25", major: "17000", after: "浩鲸****计算", unit: "算法工程师" },
        { name: "刘*", education: "29", major: "17000", after: "广州****公司", unit: "大模型开发" },
        { name: "秦*", education: "25", major: "17000", after: "****际联", unit: "技术支持" },
        { name: "孟**", education: "26", major: "16700", after: "中国**究院", unit: "算法工程师" },
        { name: "张**", education: "27", major: "16500", after: "软通**公司", unit: "技术支持" },
        { name: "申*", education: "23", major: "16000", after: "边缘**公司", unit: "算法工程师" },
        { name: "胡**", education: "23", major: "16000", after: "杭州**公司", unit: "大模型开发" },
        { name: "魏**", education: "22", major: "16000", after: "上海**公司", unit: "Agent开发" },
        { name: "赵**", education: "27", major: "16000", after: "京鲲**公司", unit: "算法工程师" },
        { name: "王*", education: "33", major: "16000", after: "哈尔**普华", unit: "RAG工程师" },
        { name: "杨*", education: "25", major: "16000", after: "****外包", unit: "算法工程师" },
        { name: "杜**", education: "22", major: "16000", after: "****游戏", unit: "开发工程师" },
        { name: "万*", education: "20", major: "15000", after: "华****", unit: "算法工程师" },
        { name: "何**", education: "27", major: "15000", after: "保密", unit: "保密" },
        { name: "林**", education: "26", major: "15000", after: "上海**科技", unit: "算法工程师" },
        { name: "陈**", education: "31", major: "14400", after: "艾瑞**公司", unit: "数据挖掘" },
        { name: "朱**", education: "31", major: "14083", after: "****银行", unit: "大模型开发" },
        { name: "胡**", education: "22", major: "14000", after: "灵泮**公司", unit: "算法工程师" },
        { name: "孙**", education: "25", major: "14000", after: "上海**公司", unit: "软件开发" },
        { name: "阳*", education: "24", major: "14000", after: "法****", unit: "Agent开发" },
        { name: "段**", education: "25", major: "14000", after: "****生物", unit: "软件开发" },
        { name: "朱**", education: "26", major: "14000", after: "中****", unit: "软件开发" },
        { name: "肖*", education: "25", major: "14000", after: "杭州**科技", unit: "算法工程师" },
        { name: "曹**", education: "24", major: "13500", after: "****讯飞", unit: "软件开发" },
        { name: "葛**", education: "26", major: "13200", after: "****动力", unit: "高级工程师" },
        { name: "李**", education: "22", major: "13000", after: "****国际", unit: "软件开发" },
        { name: "张**", education: "25", major: "13000", after: "法本**包", unit: "算法工程师" },
        { name: "罗**", education: "25", major: "13000", after: "成都**公司", unit: "数据工程师" },
        { name: "黄**", education: "26", major: "13000", after: "诚迈**公司", unit: "开发工程师" },
        { name: "陈**", education: "22", major: "13000", after: "****数字", unit: "算法工程师" },
        { name: "蒋*", education: "24", major: "13000", after: "西安**公司", unit: "算法工程师" },
        { name: "禅**", education: "25", major: "13000", after: "****集团", unit: "NLP开发" },
        { name: "李**", education: "25", major: "13000", after: "**科技", unit: "NLP工程师" },
        { name: "韩**", education: "25", major: "13000", after: "玻思**公司", unit: "软件工程师" },
        { name: "韩**", education: "33", major: "13000", after: "****汇富", unit: "大模型开发" },
        { name: "蔡**", education: "25", major: "13000", after: "保密", unit: "大模型开发" },
        { name: "闫*", education: "29", major: "12800", after: "****外包", unit: "算法工程师" },
        { name: "杨*", education: "24", major: "12700", after: "中电**公司", unit: "研发工程师" },
        { name: "严**", education: "24", major: "12500", after: "杭州**公司", unit: "AI开发" },
        { name: "张**", education: "24", major: "12000", after: "杭州**医院", unit: "大模型开发" },
        { name: "曹*", education: "23", major: "12000", after: "****动力", unit: "算法工程师" },
        { name: "韩**", education: "22", major: "12000", after: "****国际", unit: "算法工程师" },
        { name: "张*", education: "22", major: "12000", after: "南京**公司", unit: "AI开发" },
        { name: "乔**", education: "24", major: "12000", after: "北京**公司", unit: "大模型应用" },
        { name: "李**", education: "23", major: "12000", after: "****科技", unit: "软件工程师" },
        { name: "张**", education: "21", major: "12000", after: "宇通****", unit: "研发技术岗" },
        { name: "韩*", education: "23", major: "11000", after: "保密", unit: "保密" },
        { name: "黄**", education: "25", major: "11000", after: "宝德**公司", unit: "FAE" },
        { name: "汪*", education: "24", major: "11000", after: "****动力", unit: "数据分析" },
        { name: "双**", education: "23", major: "11000", after: "浙江**公司", unit: "AI工程师" },
        { name: "蒋**", education: "22", major: "11000", after: "保密", unit: "数据算法" },
        { name: "贾**", education: "23", major: "11000", after: "****汽车", unit: "算法工程师" },
        { name: "杨**", education: "25", major: "10500", after: "福州**公司", unit: "AI工程师" },
        { name: "田*", education: "25", major: "10500", after: "西安**公司", unit: "算法工程师" },
        { name: "翁**", education: "23", major: "10000", after: "保密", unit: "算法工程师" },
        { name: "姚**", education: "22", major: "10000", after: "****外包", unit: "算法工程师" },
        { name: "徐**", education: "27", major: "10000", after: "保密", unit: "算法工程师" },
        { name: "谭*", education: "24", major: "10000", after: "卓越**公司", unit: "大模型开发" },
        { name: "陈*", education: "25", major: "10000", after: "****教育", unit: "AI开发" },
      ],
      swiperOption2: {
        loop: true, // 循环模式选项

        spaceBetween: 22,
        autoplay: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          slideShadows: true, // 页面阴影效果
          rotate: 0, // 旋转的角度
          stretch: 50, // 拉伸   图片间左右的间距和密集度
          depth: 200, // 深度   切换图片间上下的间距和密集度
          modifier: 0.9, // 修正值 该值越大前面的效果越明显
        },
        pagination: {
          el: ".swiper-pagination-box12",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0 80px;

  width: 100%;
  background: linear-gradient( 180deg, #ECECFF 0%, #FFFFFF 100%);
  .btn-out{
    padding:0 32px;
  }
   .txt {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #86909c;
    line-height: 36px;
    width: 654px;
    margin: 40px auto 0;
    text-indent: -22px;
    padding-left: 22px;
  }
  /deep/ .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }

  .content {
    margin: 0 auto;
    width: 686px;
    height: 96px;
    height: 864px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow: hidden;
    margin-top: 48px;

    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);

    .border {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );

      padding: 2px;
      border-radius: 24px 24px 0 0;
      overflow: hidden;
      margin: -2px;
    }
    .swiperitems1 {
      border-radius: 0 0 24px 24px;
    }
    .swiperwrap {
      background-color: #ffffff !important;
      position: relative;
      z-index: 20;
    }
    .item {
      display: flex;

      text-align: center;
      height: 96px;
      background: #ffffff;
      line-height: 96px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #4e5969;
      box-sizing: border-box;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
    }
    .name {
      width: 120px;
      height: 96px;
    }
    .name1 {
      border-radius: 24px 0 0 0;
    }
    .education {
      width: 80px;
      height: 96px;
    }
    .before {
      width: 128px;
      height: 96px;
      color: #2800D9;
    }
    .after {
      width: 178px;
      height: 96px;

      
    }
    .unit {
      width: 170px;
      height: 96px;
    }

    .content-top {
      display: flex;
      height: 96px;
      box-sizing: border-box;
     background: linear-gradient( 180deg, #EAE6FF 0%, #F9F8FF 100%);
border-radius: 24px 0px 0px 0px;
border: 2px solid;
border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 2 2;
      width: 100%;
      div {
        // flex: 1;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d2129;
        line-height: 96px;
      }
    }
  }

  .swiper-content {
    position: relative;
    padding-bottom: 38px;
    margin-top: 80px;

    img {
      padding: 4px;
      width: 406px;
      height: 721px;
      // background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
    }

    .swiper-slide {
      display: flex;
      align-items: center;
      padding: 4px;
      width: 411px;
      height: 780px;
      // background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
    }
    .swiper-slide-active {
      img {
        width: 450px;
        height: 790px;
        border-radius: 28px;
        margin-left: -22px;
      }
    }
    .swiper-pagination-box12 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      background: rgba(46, 165, 252, 0.16);
      // width: 60px;
      // height: 6px;

      // // background: #70c3f7;
      // background: rgba(46, 165, 252, 0.16);
      // border-radius: 3px;
    }
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }
}
</style>
